// Copyright (c) 2016 Deere & Company

import LanguageSettings from '../../user/language-settings/state-connector';

export default {
    component: LanguageSettings,
    name: 'LANGUAGE',
    path: 'language'
};



// WEBPACK FOOTER //
// ./src/routes/settings/language.js